import { AlertTriangle } from 'lucide-react';
import { API_BASE } from '../lib/auth';
import type { LimitReason } from '../lib/api';

/**
 * Sprint 10 Fase 3 (F5) — modale mostrato quando il pro sbatte su un limite del
 * piano (cap pazienti, quota AI, funzione smart eco-only). Sostituisce l'errore
 * grezzo del 402 con copy chiara + CTA verso /pricing. Reason da `limitReason(err)`.
 */
const COPY: Record<LimitReason, { title: string; body: string }> = {
  patient_cap: {
    title: 'Hai raggiunto il limite di pazienti',
    body: 'Il tuo piano attuale include un numero massimo di pazienti. Passa a un piano superiore per aggiungerne altri.',
  },
  ai_quota: {
    title: 'Quota AI esaurita',
    body: 'Hai usato tutte le azioni AI incluse nel tuo piano questo mese. Passa a un piano superiore o attendi il rinnovo mensile.',
  },
  ai_smart: {
    title: 'Funzione AI avanzata',
    body: 'Il suggerimento AI avanzato è incluso dai piani a pagamento. Sul piano Avvio è disponibile solo il suggerimento base.',
  },
};

export function LimitReachedModal({ reason, onClose }: { reason: LimitReason; onClose: () => void }) {
  const { title, body } = COPY[reason];
  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          border: '2px solid var(--line, #0f1410)', borderRadius: 14, background: 'var(--paper, #fff)',
          padding: '26px 24px', maxWidth: 460, width: '100%', boxShadow: '4px 4px 0 var(--line, #0f1410)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <AlertTriangle size={20} strokeWidth={2.2} style={{ color: 'var(--green-deep, #0b8a3e)' }} />
          <h2 style={{ margin: 0, fontFamily: 'var(--display)', fontSize: 19, fontWeight: 800 }}>{title}</h2>
        </div>
        <p style={{ color: 'var(--mute, #555)', fontSize: 14, lineHeight: 1.55, margin: '0 0 18px' }}>{body}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: '1px solid var(--line, #0f1410)', background: 'var(--paper, #fff)', color: 'var(--ink, #0f1410)',
              padding: '10px 16px', borderRadius: 10, fontWeight: 700, cursor: 'pointer',
            }}
          >
            Chiudi
          </button>
          <a
            href={`${API_BASE}/pricing`}
            style={{
              display: 'inline-block', padding: '10px 18px', background: 'var(--green-deep, #0b8a3e)',
              color: '#fff', borderRadius: 10, fontWeight: 800, fontSize: 14, textDecoration: 'none',
            }}
          >
            Vedi i piani →
          </a>
        </div>
      </div>
    </div>
  );
}
